import { CurrencyPipe } from '@angular/common';
import { Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { FilterModel } from '@app/shared/models/filter-model';
import { EncrDecrService } from '@app/shared/services/encr-decr-service.service';
import { ProductService } from '@app/shared/services/product/product.service';
import { environment } from '@env/environment';
import { IClientAuthorizeCallbackData, ICreateOrderRequest, IPayPalConfig } from 'ngx-paypal';


@Component({
  selector: 'app-inventory-holding-payments',
  templateUrl: './inventory-holding-payments.component.html',
  styleUrls: ['./inventory-holding-payments.component.css']
})
export class InventoryHoldingPaymentsComponent implements OnInit {

  searchString: string;
  noRecords: boolean; 
  paymentList: any[];
  pageSize = 10;
  isFullListDisplayed: boolean = false; 
  filter: FilterModel;
  scrolling: boolean;
  totalRecordsCount: number;
  pageIndex: number;
  recordCount: any;
  userRole: any;
  @ViewChild('paymentDialog') paymentDialog: TemplateRef<any>;
  public payPalConfig?: IPayPalConfig;  // for paypal configuration
  paymentDialogRef: MatDialogRef<any>;

  constructor(private loader: LoaderService, private productservice: ProductService, public dialog: MatDialog,
    private notificationService: NotificationService, private router: Router, private activatedRoute: ActivatedRoute, private EncrDecr: EncrDecrService,
    private cp: CurrencyPipe,
    private zone: NgZone) { }

  ngOnInit() {
    this.filter = {
      searchBy: "",
      Skip: 0,
      Take: this.pageSize,
      UserId: Number(localStorage.getItem('userId'))
    };    
    this.fn_ResetList();
    this.userRole = localStorage.getItem('role');
    this.fn_getPaymentList();
  }

  fn_searchPayment() {
    this.fn_ResetList();
    this.searchString = this.searchString;
    this.filter.Skip = 0;
    this.filter.searchBy = (this.fn_CheckForNullUndefinedEmptyString(this.searchString));
    this.fn_getPaymentList();
  }

  /** Resets product list */
  fn_ResetList() {
    this.paymentList = [];
    this.isFullListDisplayed = false;
    this.scrolling = false;
    this.recordCount = 0;
    this.totalRecordsCount = 0;
    this.pageIndex = 0;
    this.filter.Skip = 0;
    this.filter.searchBy = "";
  }

  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === '' || value === undefined) {
      return '';
    } else {
      return value;
    }
  }

  fn_getPaymentList() {
    this.loader.show();
    this.filter.Skip = this.recordCount;
    this.productservice.fn_getInventoryHoldingPaymentList(this.filter).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.paymentList = [];
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
        this.loader.lazyLoaderHide();
      } else if (res.StatusCode === 204) {
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.hide();
      this.loader.lazyLoaderHide();
    });
  }

  fn_AddLazyLoadedItems(items: any) {
    this.loader.show();
    if (items !== null && items.length !== 0) {

      for (let i = 0; i < items.length; i++) {
        if (!this.paymentList.find(x => x.DesignId == items[i].DesignId)) {
          this.recordCount = this.paymentList.push(items[i]);
        }
      }
      this.noRecords = this.recordCount > 0 ? false : true;
    }
    if (items.length < this.pageSize) {
      this.isFullListDisplayed = true;
    }
    this.loader.hide();
  }

  fn_Pay(recordId: number, paymentAmount: number, createdDate: Date) {
    this.paymentDialogRef = this.dialog.open(this.paymentDialog, { 
      data: { 
        PaymentAmount: paymentAmount, 
        PaymentCreatedDate: createdDate 
      }, width: '270px' });
    this.fn_PaypalInitConfig(recordId, paymentAmount);
  }

  
  fn_PaypalInitConfig(recordId, paymentAmount: number): void {
    this.payPalConfig = {
      currency: 'USD',
      clientId: environment.paypalPublicKey,
      createOrderOnClient: (data): ICreateOrderRequest => {
        return {
          intent: 'CAPTURE',
          application_context: {
            brand_name: "MerchLoop",
            shipping_preference: "NO_SHIPPING"
          },
          purchase_units: [{
            amount: {
              currency_code: 'USD',
              value: (this.cp.transform(paymentAmount, '', '', '1.2-2')).toString(),
              breakdown: {
                item_total: {
                  currency_code: 'USD',
                  value: (this.cp.transform(paymentAmount, '', '', '1.2-2')).toString()
                }
              }
            },
            items: [{
              name: "WP_IHP_" + this.filter.UserId,
              quantity: '1',
              category: 'PHYSICAL_GOODS',
              unit_amount: {
                currency_code: 'USD',
                value: (this.cp.transform(paymentAmount, '', '', '1.2-2')).toString()
              },
            }]
          }]
        };
      },
      advanced: {
        commit: 'true'
      },
      style: {
        label: 'pay',
        layout: 'horizontal'
      },
      
      onApprove: (data, actions) => {
      },
      onClientAuthorization: (data: IClientAuthorizeCallbackData) => {
        this.zone.run(() => {          
          this.fn_PaymentSuccess(recordId, data);
        });
      },
      onCancel: (data, actions) => {
        this.notificationService.info('Your transaction has been cancelled', 'Payment');
        this.fn_ResetList();
        this.fn_getPaymentList();
      },
      onError: err => {
        alert("Payment failed !!!");
        this.fn_ResetList();
        this.fn_getPaymentList();
      },
      onClick: (data, actions) => {
      },
    };
  }
  fn_PaymentSuccess(recordId, data: IClientAuthorizeCallbackData) {
    this.loader.show();
    let paymentDetails = {
      InventoryHoldingPaymentId: recordId,
      PaymentId : data.id,
      PayerId : data.payer.payer_id
    };
    this.loader.show();
    this.productservice.fn_SaveInventoryHoldingPayment(paymentDetails).subscribe((res: any) => {
      this.loader.hide();
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, "Success");
        this.paymentDialogRef.close(true);
        this.fn_ResetList();
        this.fn_getPaymentList();
      } else {
        this.notificationService.error(res.Message, "error");
      }
    }, (err: any) => {
      this.loader.hide();
      console.error(err);
    });

  }

}
